export default "__VITE_ASSET__3aee4ed0__"